// AutoSpa5 Brand Configuration
// Logo and asset URLs
export const BRAND_ASSETS = {
  logo: 'https://customer-assets.emergentagent.com/job_quick-wash-24/artifacts/wkav3cv7_Progetto%20senza%20titolo%20%2817%29.png',
  vipCardFront: 'https://customer-assets.emergentagent.com/job_quick-wash-24/artifacts/yqbeqzet_Vip%20Card%20Fronte.png.png',
  portal: 'https://customer-assets.emergentagent.com/job_quick-wash-24/artifacts/kqlwiias_Portale%20Autospa5.png',
  // Local WebP — 384 KB (down from 2.6 MB PNG) for fast splash photo decode on mobile.
  splashCarPortal: '/assets/splash_portal.webp',
};

// Backend feature-chip values mapped to translation keys.
// Backend stores features as literal English strings; the frontend translates at render time.
export const CHIP_TRANSLATION_MAP = {
  // Current Awoara-style chips (Iter34 poster spec)
  'Wheels & underbody': 'chipWheels',
  'High pressure ×1': 'chipHighPressure1',
  'High pressure ×2': 'chipHighPressure2',
  'Pre-wash foam': 'chipPreWashFoam',
  'Active PRO foam': 'chipActiveFoam',
  'Spotless PRO drying': 'chipSpotlessDry',
  'Spotless drying': 'chipSpotlessDrySimple',
  'No drying': 'chipNoDrying',
  'Tire shine': 'chipTireShine',
  'Protective candle wax': 'chipQiri',
  'Nano Wax': 'chipNanoWax',
};

// Luxury-only highlighted block — sub-bullets rendered under the "Nano Wax" chip.
export const NANO_WAX_BULLET_KEYS = ['nanoWaxBullet1', 'nanoWaxBullet2', 'nanoWaxBullet3'];
// "Luxury + Pastrim i brendshëm" combo discount (LEK) shown on the Luxury card.
export const LUXURY_INTERIOR_COMBO_DISCOUNT = 100;

// Program configuration with car images - NEVER CHANGE PROGRAM NAMES
export const PROGRAM_CONFIG = {
  fast: {
    name: 'Fast', // NEVER translate
    color: '#6B7280', // Gray
    colorLight: 'rgba(107, 114, 128, 0.2)',
    colorDark: 'rgba(107, 114, 128, 0.1)',
    carImage: 'https://customer-assets.emergentagent.com/job_quick-wash-24/artifacts/eesh1anf_6.png',
    tier: 1,
  },
  basic: {
    name: 'Basic', // NEVER translate
    color: '#3B82F6', // Blue
    colorLight: 'rgba(59, 130, 246, 0.2)',
    colorDark: 'rgba(59, 130, 246, 0.1)',
    carImage: 'https://customer-assets.emergentagent.com/job_quick-wash-24/artifacts/a03p4zcm_5.png',
    tier: 2,
  },
  economic: {
    name: 'Economic+', // NEVER translate
    color: '#22C55E', // Green
    colorLight: 'rgba(34, 197, 94, 0.2)',
    colorDark: 'rgba(34, 197, 94, 0.1)',
    carImage: 'https://customer-assets.emergentagent.com/job_quick-wash-24/artifacts/5xinvxpq_4.png',
    tier: 3,
  },
  standard: {
    name: 'Standard', // NEVER translate
    color: '#FF5A00', // Orange (brand secondary)
    colorLight: 'rgba(255, 90, 0, 0.2)',
    colorDark: 'rgba(255, 90, 0, 0.1)',
    carImage: 'https://customer-assets.emergentagent.com/job_quick-wash-24/artifacts/8zi3x1ft_Fast%203.png',
    isMostPopular: true,
    tier: 4,
  },
  luxury: {
    name: 'Luxury', // NEVER translate
    color: '#EF4444', // Red
    colorLight: 'rgba(239, 68, 68, 0.2)',
    colorDark: 'rgba(239, 68, 68, 0.1)',
    carImage: 'https://customer-assets.emergentagent.com/job_quick-wash-24/artifacts/cj0pjvsq_2.png',
    isPremium: true,
    tier: 5,
  }
};

// Map program_id or name to config key
export const getProgramConfig = (programIdOrName) => {
  const idMapping = {
    'prog_fast': 'fast',
    'prog_basic': 'basic',
    'prog_economic': 'economic',
    'prog_standard': 'standard',
    'prog_luxury': 'luxury',
  };
  
  const nameMapping = {
    'Fast': 'fast',
    'Basic': 'basic',
    'Economic+': 'economic',
    'Standard': 'standard',
    'Luxury': 'luxury',
  };
  
  const key = idMapping[programIdOrName] || nameMapping[programIdOrName];
  return PROGRAM_CONFIG[key] || PROGRAM_CONFIG.basic;
};

// Get subtitle key for translations
export const getProgramSubtitleKey = (programName) => {
  const mapping = {
    'Fast': 'fastSubtitle',
    'Basic': 'basicSubtitle',
    'Economic+': 'economicSubtitle',
    'Standard': 'standardSubtitle',
    'Luxury': 'luxurySubtitle',
  };
  return mapping[programName] || 'basicSubtitle';
};

// Get description key for translations
export const getProgramDescKey = (programName) => {
  const mapping = {
    'Fast': 'fastDesc',
    'Basic': 'basicDesc',
    'Economic+': 'economicDesc',
    'Standard': 'standardDesc',
    'Luxury': 'luxuryDesc',
  };
  return mapping[programName] || 'basicDesc';
};

// Brand colors
export const BRAND = {
  primary: '#0ABAB5', // Tiffany
  primaryGlow: 'rgba(10, 186, 181, 0.4)',
  primaryLight: 'rgba(10, 186, 181, 0.15)',
  secondary: '#FF5A00', // Orange
  secondaryGlow: 'rgba(255, 90, 0, 0.4)',
  secondaryLight: 'rgba(255, 90, 0, 0.15)',
  gold: '#FFD700',
  goldLight: 'rgba(255, 215, 0, 0.15)',
  background: '#050505',
  backgroundSecondary: '#0a0a0a',
  backgroundTertiary: '#121212',
  surface: 'rgba(255, 255, 255, 0.05)',
  surfaceHover: 'rgba(255, 255, 255, 0.08)',
  border: 'rgba(255, 255, 255, 0.08)',
  borderActive: '#0ABAB5',
  textPrimary: '#FFFFFF',
  textSecondary: '#A1A1AA',
  textTertiary: '#71717A',
  success: '#22C55E',
  error: '#EF4444',
  warning: '#F59E0B',
};

// Subscription plan mapping
export const SUBSCRIPTION_PROGRAMS = {
  'plan_economic': 'Economic+',
  'plan_standard': 'Standard',
  'plan_luxury': 'Luxury',
  'plan_unlimited': 'Standard',
};

// Visible order for subscription plans (ascending).
export const PLAN_ORDER = {
  'plan_economic': 1,
  'plan_standard': 2,
  'plan_luxury': 3,
  'plan_unlimited': 4,
};

